/* All top-level, first-class Business Units that Ratehub.ca supports.

WARNING: It may not be the best idea to loop over this file and just use whatever
is here blindly, as this list can change. It shouldn't change often, but it can
and you may not wish for changes here to automatically be reflected in your
components, stories, tests etc. If that's what you want, great - but if not,
you might consider making a separate map which includes just the business units
YOU care about. */

const BusinessUnitsEN = {
    MORTGAGES: 'mortgages',
    CREDIT_CARDS: 'credit-cards',
    BANKING: 'banking',
    INVESTING: 'investing',
    INSURANCE: 'insurance',
    CRYPTO: 'crypto',
    LOANS: 'loans',
    ALL: 'all',
};

const BusinessUnitsFR = {
    MORTGAGES: 'hypotheques',
    CREDIT_CARDS: 'cartes-de-credit',
    BANKING: 'comptes',
    INVESTING: 'placements',
    INSURANCE: 'assurance',
    CRYPTO: 'crypto', // TODO: update when it's defined
    LOANS: 'prêts',
    ALL: 'tout',
};

export default BusinessUnitsEN;
export { BusinessUnitsFR };
